var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7812 7.53125C16.075 7.2375 16.075 6.7625 15.7812 6.47188L11.2812 1.96875C11.0656 1.75312 10.7437 1.69063 10.4625 1.80625C10.1812 1.92188 10 2.19688 10 2.5V5H6.5C5.67188 5 5 5.67188 5 6.5V7.5C5 8.32812 5.67188 9 6.5 9H10V11.5C10 11.8031 10.1812 12.0781 10.4625 12.1938C10.7437 12.3094 11.0656 12.2469 11.2812 12.0312L15.7812 7.53125ZM5 2C5.55312 2 6 1.55313 6 1C6 0.446875 5.55312 0 5 0H3C1.34375 0 0 1.34375 0 3V11C0 12.6562 1.34375 14 3 14H5C5.55312 14 6 13.5531 6 13C6 12.4469 5.55312 12 5 12H3C2.44688 12 2 11.5531 2 11V3C2 2.44688 2.44688 2 3 2H5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7f2cc594f470b9b1318e2e13569fef22.svg";
export { ForwardRef as ReactComponent };